module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.9075/img/cms-free-signup-2x.png"